import { createContext, ReactNode, useContext } from "react";

import { useFilterQuoteAccommodation } from "./filter-quote-accommodation.hook";

const FilterQuoteAccommodationContext = createContext(
  {} as ReturnType<typeof useFilterQuoteAccommodation>
);
export function useFilterQuoteAccommodationContext() {
  return useContext(FilterQuoteAccommodationContext);
}

interface FilterQuoteAccommodationProviderProps {
  children: ReactNode;
}
export function FilterQuoteAccommodationProvider({
  children,
}: FilterQuoteAccommodationProviderProps) {
  return (
    <FilterQuoteAccommodationContext.Provider value={useFilterQuoteAccommodation()}>
      {children}
    </FilterQuoteAccommodationContext.Provider>
  );
}